import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { AvailableManualModel } from "../models/available-manual-model";

@Injectable()
export class ManualDataService extends ApiDataService {
    constructor() {
        super("manuals");
    }

    public getManuals() {
        return this.get<AvailableManualModel[]>();
    }
}
